import React, { createContext, useContext, useState } from 'react';

const SessionContext = createContext();

export const SessionProvider = ({ children }) => { 
  const [loginName, setLoginName] = useState(null);   
  
  return (
    <SessionContext.Provider value={{ loginName, setLoginName }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  return useContext(SessionContext);
};
